// Core service area zip codes within the polygon delivery zone
export const coreServiceZipCodes = [
  // Los Angeles County - South/Central
  '90001', '90002', '90003', '90004', '90005', '90006', '90007', '90008', '90010',
  '90011', '90012', '90013', '90014', '90015', '90016', '90017', '90018', '90019',
  '90020', '90021', '90022', '90023', '90024', '90025', '90026', '90027', '90028',
  '90029', '90031', '90032', '90033', '90034', '90035', '90036', '90037', '90038',
  '90039', '90040', '90041', '90042', '90043', '90044', '90045', '90046', '90047',
  '90048', '90049', '90056', '90057', '90058', '90059', '90061', '90062', '90063',
  '90064', '90065', '90066', '90067', '90068', '90069',

  // Los Angeles County - East
  '91731', '91732', '91733', '91734', '91735', '91740', '91741', '91744', '91745',
  '91746', '91747', '91748', '91749', '91750', '91754', '91755', '91756', '91765',
  '91766', '91767', '91768', '91769', '91770', '91771', '91772', '91773',

  // San Bernardino County - West
  '91701', '91708', '91709', '91710', '91729', '91730', '91737', '91739', '91743',
  '91758', '91759', '91761', '91762', '91763', '91764', '91784', '91785', '91786',

  // Riverside County - Northwest
  '91752', '92501', '92502', '92503', '92504', '92505', '92506', '92507', '92508',
  '92509', '92518', '92551', '92553', '92557',

  // Orange County
  '92701', '92702', '92703', '92704', '92705', '92706', '92707', '92708', '92780',
  '92781', '92782', '92799', '92801', '92802', '92803', '92804', '92805', '92806',
  '92807', '92808', '92809', '92821', '92822', '92823', '92825', '92831', '92832',
  '92833', '92834', '92835', '92836', '92837', '92838', '92840', '92841', '92842',
  '92843', '92844', '92845', '92846', '92850', '92856', '92857', '92859', '92861',
  '92862', '92863', '92864', '92865', '92866', '92867', '92868', '92869', '92870',
  '92871', '92885', '92886', '92887'
];